package network

import io.ktor.client.*
import io.ktor.client.plugins.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json

/**
 * Singleton HttpClient — reutilizado en toda la app.
 * No llamar .close() sobre esta instancia.
 * FIX #16: Retry automático para Cloud Functions con cold start (~3-5s).
 */
val sharedHttpClient: HttpClient by lazy {
    HttpClient {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                prettyPrint = true
            })
        }
        install(HttpTimeout) {
            requestTimeoutMillis = 60_000  // Ampliado: CFs cold start puede tardar
            connectTimeoutMillis = 15_000
            socketTimeoutMillis = 60_000
        }
        install(HttpRequestRetry) {
            retryOnServerErrors(maxRetries = 2)
            retryOnException(maxRetries = 2, retryOnTimeout = true)
            exponentialDelay()
        }
    }
}
